
import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Home from "./pages/Home";
import Login from "./pages/Login";
import SearchAI from "./pages/SearchAI";
import SearchManual from "./pages/SearchManual";
import SearchMap from "./pages/SearchMap";
import DarkModeContext from "./context/DarkModeContext";

function App() {
  const [darkMode, setDarkMode] = useState(() => {
    const stored = localStorage.getItem("darkMode");
    return stored === "true" ? true : false;
  });

  const toggleDarkMode = () => {
    setDarkMode((prev) => {
      localStorage.setItem("darkMode", !prev);
      return !prev;
    });
  };

  useEffect(() => {
    if (darkMode) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, [darkMode]);

  return (
    <DarkModeContext.Provider value={{ darkMode, toggleDarkMode }}>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/search-ai" element={<SearchAI />} />
          <Route path="/search-manual" element={<SearchManual />} />
          <Route path="/search-map" element={<SearchMap />} />
        </Routes>
      </Router>
    </DarkModeContext.Provider>
  );
}

export default App;
